import { render } from "./Activities.vue?vue&type=template&id=0c2260bc&scoped=true&bindings={\"activityResult\":\"options\",\"activities\":\"data\",\"name\":\"props\",\"location\":\"props\",\"locations\":\"props\",\"url\":\"props\",\"address\":\"props\"}"
import script from "./Activities.vue?vue&type=script&lang=js"
export * from "./Activities.vue?vue&type=script&lang=js"

import "./Activities.vue?vue&type=style&index=0&id=0c2260bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c2260bc"

export default script